import {
  LOGIN_REQUEST,
  REGISTER_REQUEST,
  LOGOUT,
  GET_PROFILE,
  UPDATE_PROFILE,
  SET_MODAL,
  RESTORE_AUTH,
  RESET_PASSWORD,
  SET_PROTECTED_REFERRER,
  SET_SYS_LOCALE,
  VALIDATE_EMAIL,
  SET_REGISTER_FORM,
  SET_VALIDATE_MODAL,
  SEND_REFER,
  SEND_VOUCHER_CODE,
  GET_VOUCHERS,
  CHECKOUT_DISCOUNT_VOUCHERS,
  SET_GUEST_USER,
  SEND_SMS,
  VERIFY_CODE,
  GET_BALANCE,
  DELETE_USER,
  GET_STUDENT_BEANS_URL,
  SEND_VALIDATION_EMAIL,
  SEND_EMAIL_CODE,
  CLEAR_REGISTER_FORM
} from './constants';
/**
 * Tells the app we want to log in a user
 * @param { object } data The data we're sending for log in
 * @param { string } data.username The username of the user to log in
 * @param { string } data.password The password of the user to log in
 */
export const loginRequest = (data) => ({ type: LOGIN_REQUEST, ...data });

/**
 * Tells the app we want to register a user
 * @param { object } data The data we're sending for registration
 * @param { string } data.email The email of the user to register
 * @param { string } data.password The password of the user to register
 */
export const registerRequest = (data) => ({ type: REGISTER_REQUEST, data });

export const resetPassword = (data) => ({ type: RESET_PASSWORD, data });

export const getProfile = () => ({ type: GET_PROFILE });

export const updateProfile = (data, skipAlert = false) => ({
  type: UPDATE_PROFILE,
  data,
  skipAlert,
});
export const setGuestUser = (value) => ({ type: SET_GUEST_USER, value });

export const setModal = (modal, value) => ({ type: SET_MODAL, modal, value });

export const logout = (cb = null) => ({ type: LOGOUT, cb });

export const restoreAuth = () => ({ type: RESTORE_AUTH });

export const setProtectedReferrer = (path) => ({ type: SET_PROTECTED_REFERRER, path });

export const setSysLocale = (sysLocale) => ({ type: SET_SYS_LOCALE, sysLocale });

export const validateEmail = (validate_profile) => ({ type: VALIDATE_EMAIL, validate_profile });

export const setRegisterForm = (key, value) => ({ type: SET_REGISTER_FORM, key, value });
export const clearRegisterForm = () => ({ type: CLEAR_REGISTER_FORM});

export const setValidateModal = (isValidetePopUpDisplayed) => ({
  type: SET_VALIDATE_MODAL,
  isValidetePopUpDisplayed,
});

export const sendRefer = (data) => ({ type: SEND_REFER, data });
export const sendSMS = (value) => ({ type: SEND_SMS, value });
export const verifyCode = (data) => ({ type: VERIFY_CODE, data });

export const sendVoucherCode = (data, orderCreated) => ({
  type: SEND_VOUCHER_CODE,
  data,
  orderCreated,
});
export const getVouchers = () => ({ type: GET_VOUCHERS });

export const checkDiscount = (data) => ({ type: CHECKOUT_DISCOUNT_VOUCHERS, data });

export const getBalance = () => ({ type: GET_BALANCE });

export const deleteUser = (token) => ({ type: DELETE_USER, token });

export const getStudentBeansUrl = (data) => ({ type: GET_STUDENT_BEANS_URL,data });

export const sendValidationEmail = () => ({ type: SEND_VALIDATION_EMAIL });

export const sendEmailCode = (data) => ({ type: SEND_EMAIL_CODE, data });

